import * as React from 'react';
import { EPageTypes, EPlatformTypes, SimpleCall } from '@cian/frontend-newbuilding-call-component';
import { IconCommunicationPhone16 } from '@cian/ui-kit-design-tokens/icons';
import { useSelector } from 'react-redux';

import { getNewbuildingId } from '../../selectors/newbuilding';
import { BuilderChatButtonContainer } from '../BuilderChatButton';
import { trackShowPhone } from './tracking';
import { useApplicationContext } from '../../utils/applicationContext';
import { INewbuildingBuilder } from '../../types/newbuilding/builder';
import { getGALabel } from '../../selectors/newbuilding/getGALabel';
import { UIHeading2 } from '@cian/ui-kit';

interface IContactsContainerProps {
  builder: INewbuildingBuilder;
}

const CALL_BUTTON_STYLES = {
  size: 'M' as const,
  beforeIcon: <IconCommunicationPhone16 color="icon-inverted-default" />,
};

export function ContactsContainer({ builder }: IContactsContainerProps) {
  const gaLabel = useSelector(getGALabel);
  const newbuildingId = useSelector(getNewbuildingId);

  const hasPhone = builder.phone && builder.phone.number;
  const hasChat = builder.chat?.isEnabled && builder.realtyUserId;

  const chatContacts = React.useMemo(() => {
    return {
      builders: [builder],
      sellers: [],
    };
  }, [builder]);

  const { httpApi, logger } = useApplicationContext();

  const pageType = EPageTypes.NewbuildingCard;
  const platformType = EPlatformTypes.WebDesktop;
  const placeType = 'Open_jk_card_author_block';

  const onShowPhoneClick = React.useCallback(() => {
    trackShowPhone({
      gaLabel,
      newbuildingId,
      isBuilder: true,
    });
  }, [gaLabel, newbuildingId]);

  if (!hasPhone && !hasChat) {
    return null;
  }

  return (
    <>
      {hasPhone && (
        <SimpleCall
          builders={[builder]}
          sellers={[]}
          onShowPhoneClick={onShowPhoneClick}
          openContactsStyles={CALL_BUTTON_STYLES}
          showPhoneStyles={CALL_BUTTON_STYLES}
          httpApi={httpApi}
          logger={logger}
          pageType={pageType}
          platformType={platformType}
          placeType={placeType}
          singlePhoneButtonText="Показать телефон"
          SinglePhoneComponent={({ phone }: { phone: string }) => <UIHeading2 whiteSpace="nowrap">{phone}</UIHeading2>}
        />
      )}
      {hasChat && (
        <BuilderChatButtonContainer
          forcedContacts={chatContacts}
          placeType={placeType}
          buttonTheme="fill_white_primary"
        />
      )}
    </>
  );
}
